import { Role } from '../../../api/types';
import { FirebaseUser } from '../../../api/user/types';
import { Domains } from '../../../constants';
import { ErrorTypes } from './types';

const LOCALSTORAGE_KEY = '(from localstorage)';

export const getSentryPanalytTags = (params: {
  subDomain: string | null;
  domain: Domains | null;
  domainFromLocalStorage: Domains | null;
  executorRole: Role | null;
  executorRoleFromLocalStorage: Role | null;
  simulatedRole: Role | null;
  currentUser: FirebaseUser | null;
  currentUserFromLocalStorage: FirebaseUser | null;
  errorType?: ErrorTypes;
}) => {
  const {
    subDomain,
    domain,
    domainFromLocalStorage,
    executorRole,
    executorRoleFromLocalStorage,
    simulatedRole,
    currentUser,
    currentUserFromLocalStorage,
    errorType,
  } = params;
  return {
    'panalyt.errorType': errorType ?? 'general',
    'panalyt.domain':
      domain ??
      (domainFromLocalStorage
        ? `${domainFromLocalStorage} ${LOCALSTORAGE_KEY}`
        : undefined),
    'panalyt.subDomain': subDomain,
    'panalyt.executorRole.id':
      executorRole?.id ??
      (executorRoleFromLocalStorage
        ? `${executorRoleFromLocalStorage.id} ${LOCALSTORAGE_KEY}`
        : undefined),
    'panalyt.executorRole.name':
      executorRole?.name ??
      (executorRoleFromLocalStorage
        ? `${executorRoleFromLocalStorage.name} ${LOCALSTORAGE_KEY}`
        : undefined),
    'panalyt.executorRole.domain':
      executorRole?.domain ??
      (executorRoleFromLocalStorage && executorRoleFromLocalStorage.domain
        ? `${executorRoleFromLocalStorage.domain} ${LOCALSTORAGE_KEY}`
        : undefined),
    'panalyt.simulatedRole.id': simulatedRole?.id,
    'panalyt.simulatedRole.name': simulatedRole?.name,
    'panalyt.simulatedRole.domain': simulatedRole?.domain,
    'panalyt.currentUser.email':
      currentUser?.email ??
      (currentUserFromLocalStorage && currentUserFromLocalStorage.email
        ? `${currentUserFromLocalStorage.email} ${LOCALSTORAGE_KEY}`
        : undefined),
  };
};
